module.exports = __webpack_public_path__ + "static/6-5a47472ea7f2a7ce2c6b47622b5494f8.jpg";